import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { AuthService } from 'app/services/auth.service';
import { ProjectService } from 'app/services/models/project.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-project-create',
  templateUrl: './project-create.component.html',
  styleUrls: ['./project-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectCreateComponent implements OnInit, OnChanges {
  @Input() data: number;
  projectForm: FormGroup;

  constructor(
    private _coreSidebarService: CoreSidebarService,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private projectServic: ProjectService,
    public authService: AuthService
  ) { }


  async ngOnInit() {
    this.initializeForm();
    console.log(this.data);
    if (this.data) {
      await this.getByIdProject(this.data);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && changes['data'].currentValue) {
      this.getByIdProject(changes['data'].currentValue);
    }
  }

  initializeForm() {
    this.projectForm = this.formBuilder.group({
      projectName: ['', [Validators.required, Validators.maxLength(100)]],
      description: [''], // Açıklama zorunlu değil
      budget: [0], // Proje Fiyatı zorunlu değil
      status: [null]
    });
  }

  async onSubmit() {
    if (this.projectForm.valid) {
      console.log(this.projectForm.value);
      const data = await this.projectServic.createProject(
        this.projectForm.value.projectName,
        this.projectForm.value.description,
        this.projectForm.value.budget
      );
      if (data.status == true) {
        this.projectServic.sendEvent(true);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }
    } else {
      this.toastrService.error("Formu doğru doldurunuz.");
    }
  }

  async onUpdate() {
    if (this.projectForm.valid) {
      const data = await this.projectServic.updateProject(
        this.data,
        this.projectForm.value.projectName,
        this.projectForm.value.description,
        this.projectForm.value.budget,
        this.projectForm.value.status);
      if (data.status) {
        this.projectServic.sendEvent(true);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }
    }
  }

  toggleSidebar(name: string): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  async getByIdProject(id: number) {
    console.log(id);
    const data = await this.projectServic.getByIdProject(id);
    console.log(data);
    this.projectForm.patchValue({
      projectName: data.name,
      description: data.description, // Açıklama zorunlu değil
      budget: data.budget, // Proje Fiyatı zorunlu değil
      status: data.status
    });
  }

  status = [
    { id: 1, name: "Devam Ediyor" },
    { id: 2, name: "İptal Edildi" },
    { id: 3, name: "Tamamlandı" },
  ];
  
  hasPermission(): boolean {
    if (this.data) {
      return this.authService.isEndpointStatus('PUT.Writing.UpdateProject');
    } else {
      return this.authService.isEndpointStatus('POST.Writing.CreateProject');
    }
  }
}
